import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { messages } from "./languages";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "es",
    supportedLngs: ["pt", "pt-BR", "en", "es", "fr", "it"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    defaultNS: ["translations"],
    ns: ["translations"],
    resources: messages,
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    }
  });

export { i18n };
